import { useState } from "react";
import { AuthProvider, useAuth } from "./AuthContext.jsx";
import LoginScreen from "./LoginScreen.jsx";
import Layout from "./Layout.jsx";
import AnfragenScreen from "./screens/AnfragenScreen.jsx";
import AuftraegeScreen from "./screens/AuftraegeScreen.jsx";
import PipelineScreen from "./screens/PipelineScreen.jsx";
import SocialScreen from "./screens/SocialScreen.jsx";
import KiToolsScreen from "./screens/KiToolsScreen.jsx";
import KostenScreen from "./screens/KostenScreen.jsx";
import MaterialScreen from "./screens/MaterialScreen.jsx";
import TeamScreen from "./screens/TeamScreen.jsx";

function Dashboard() {
  const [active, setActive] = useState("anfragen");
  const screens = {
    anfragen: <AnfragenScreen />,
    auftraege: <AuftraegeScreen />,
    pipeline: <PipelineScreen />,
    social: <SocialScreen />,
    ki: <KiToolsScreen />,
    kosten: <KostenScreen />,
    material: <MaterialScreen />,
    team: <TeamScreen />,
  };
  return (
    <Layout active={active} onNavigate={setActive}>
      {screens[active]}
    </Layout>
  );
}

function Gate() {
  const { user } = useAuth();
  if (user === undefined) return <div style={{ padding: 40 }}>Lade…</div>;
  if (user === null) return <LoginScreen />;
  return <Dashboard />;
}

export default function App() {
  return (
    <AuthProvider>
      <Gate />
    </AuthProvider>
  );
}
